import { mergeRegister } from '@lexical/utils';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  COMMAND_PRIORITY_HIGH,
  createCommand,
  FORMAT_ELEMENT_COMMAND,
  LexicalEditor,
} from 'lexical';
import { $isCustomListItemNode } from 'modules/Lexical/nodes/CustomListItemNode';
import * as Constants from 'const';
import * as Models from 'models';
import { FONT_COMMAND } from '../FontPlugin/commands';
import { TEXT_BLOCK_COMMAND } from '../TextBlockPlugin';
import {
  $isSelectionForListItem,
  $getTopLevelCustomListFromSelection,
  $removeCustomListAndKeepStyles,
  $insertCustomListAndKeepStyles,
} from './utils';

export const BULLET_TOGGLE = createCommand<string | undefined>();
export const BULLET_COLOR_COMMAND = createCommand<Models.BrandColorMap | undefined>();

export function registerCommands(
  editor: LexicalEditor,
  brandStyleHeadingTag?: Constants.HeadingTagType,
): () => void {
  return mergeRegister(
    editor.registerCommand(
      BULLET_TOGGLE,
      () => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          return false;
        }
        const isList = $isSelectionForListItem();
        if (isList) {
          $removeCustomListAndKeepStyles(brandStyleHeadingTag);

          return true;
        }
        $insertCustomListAndKeepStyles();

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    ),
    editor.registerCommand(
      BULLET_COLOR_COMMAND,
      (color) => {
        const list = $getTopLevelCustomListFromSelection();
        if (list) {
          list.setColor(color?.toJS());

          return true;
        }

        return false;
      },
      COMMAND_PRIORITY_EDITOR,
    ),

    editor.registerCommand(
      FONT_COMMAND.SIZE,
      (size) => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const nodes = selection.getNodes();
          const listItemNodes = nodes.filter($isCustomListItemNode);
          if (listItemNodes.length) {
            listItemNodes.forEach(node => node.setFontSize(size));
          } else {
            const [firstNode] = nodes;
            const parent = firstNode.getParent();
            if ($isCustomListItemNode(parent)) {
              parent.setFontSize(size);
            }
          }
        }

        return false;
      },
      COMMAND_PRIORITY_HIGH,
    ),

    editor.registerCommand(
      TEXT_BLOCK_COMMAND.BLOCK_TYPE,
      (value) => {
        if (value === Constants.TextHorizontalAlignmentType.UNORDERED_LIST) {
          editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left');
          editor.dispatchCommand(BULLET_TOGGLE, undefined);

          return true;
        }
        const isList = $isSelectionForListItem();
        if (isList) {
          editor.dispatchCommand(BULLET_TOGGLE, undefined);
        }

        return false;
      },
      COMMAND_PRIORITY_HIGH,
    ),
  );
}
